import React from 'react';

const callouts = [
  {
    emoji: '📌',
    title: 'The friction is real',
    text: "From getting work done to getting paid for it, every step has unnecessary friction, and it costs people time, money, and trust.",
  },
  {
    emoji: '🌍',
    title: 'Africa deserves better infrastructure',
    text: "The talent is here. The ideas are here. The tools haven't caught up. We're changing that.",
  },
  {
    emoji: '⚙️',
    title: 'Technology should remove problems, not create them',
    text: "We build with one rule: if it doesn't make something meaningfully easier, it doesn't ship.",
  },
];

const Core = () => {
  return (
    <section className="core" id="problem">
      <div className="core__glow" />

      <div className="core__content reveal">
        <div className="core__label">
          {'// WHY WE\'RE BUILDING THIS'}
        </div>
        <h2 className="core__title">
          The digital economy is broken in ways most people have
          just <span className="accent">accepted</span>.
        </h2>
        <p className="core__description">
          Work gets lost in email threads. Payments fall through. Good people go
          unfound. Great ideas stall because the right tools don't exist, or
          exist somewhere else in the world, built for someone else's context.
        </p>
        <p className="core__description">
          We've seen it firsthand. We got tired of accepting it. So we built the fix.
        </p>
      </div>

      <div className="core__callouts">
        {callouts.map((c, i) => (
          <div className={`core__callout reveal reveal-delay-${i + 1}`} key={i}>
            <span className="core__callout-emoji">{c.emoji}</span>
            <h3 className="core__callout-title">{c.title}</h3>
            <p className="core__callout-text">{c.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Core;
